<template>
  <div class="overview">
    <!--更换空间和设备类型标签列表在同一行-->
    <div class="header-container">
      <!-- 空间选择器 -->
      <div class="space-selector">
        <img
          src="../../assets/images/index/roomIcon.png"
          style="margin-top: 10px;float: left;margin-right: 5px;"
        />
        <div style="line-height: 40px; display: inline-block;">
          <span style="color: rgba(7, 230, 248, 1)">{{ currentSpaceInfo.title }}</span>
          <a
            class="pointer text-white"
            style="margin-left: 10px;"
            @click="clickSpaceTree"
          >更换空间</a>
        </div>
        <space-choose
          @close="spaceTreeDisable = false"
          @spaceClick="spaceClick"
          :currentSpaceInfo="currentSpaceInfo"
          ref="spaceChoose"
          v-show="spaceTreeDisable"
        ></space-choose>
      </div>

      <!-- 设备类型标签列表 - 水平导航样式 -->
      <div class="device-nav-container">
        <ul class="device-nav">
          <li 
            :key="item.id" 
            class="device-nav-item" 
            :class="{ 'active': item.isCheck }"
            v-for="item in tagList"
            @click="changeInput(item.id, item.name)">
            {{item.name.includes('PTMS') ? item.name : item.name + '态势' }}
          </li>
        </ul>
      </div>
    </div>

    <!--内景图展示-->
    <indoor-setting-view
      :currentSpaceInfo="currentSpaceInfo"
      :tagSelected="tagSelected"
      :tagCode="tagSelectedCode"
      :screenDatas="screenDatas"
      :highlightDeviceId="highlightDeviceId"
      ref="indoor"
    ></indoor-setting-view>
  </div>
</template>
  
<script>
import SpaceChoose from "@/views/space_overview/SpaceChoose";
import IndoorSettingView from "@/views/space_overview/IndoorSettingView";
import {getListByParentCode} from "@/network/extension";

export default {
  name: "space_overview",
  components: {
    IndoorSettingView,
    SpaceChoose
  },
  data() {
    return {
      currentSpaceInfo: { id: "0", title: "暂无空间" },
      spaceTreeDisable: false,
      // 从IndoorSettingView移过来的数据
      tagList: [],
      tagSelected: '',
      tagSelectedCode: '',
      labelName: "动力",
      screenDatas: [],
      highlightDeviceId: '', // 需要高亮显示的设备ID
    };
  },
  mounted() {
    // 检查是否有路由参数（从告警中心或其他页面跳转过来）
    if (this.$route.query.spaceId) {
      this.currentSpaceInfo = {
        id: this.$route.query.spaceId,
        title: this.$route.query.spaceName
      };
      this.$cookies.set(
        "currentSpaceInfo",
        JSON.stringify(this.currentSpaceInfo)
      );
      
      // 如果路由参数中有 tagId，保存到 cookie
      if (this.$route.query.tagId) {
        this.$cookies.set("selectedTagId", this.$route.query.tagId);
      }
      
      // 如果路由参数中有 deviceId，保存到 cookie（用于高亮显示设备）
      if (this.$route.query.deviceId) {
        this.$cookies.set("highlightDeviceId", this.$route.query.deviceId);
      }
      
      // 清理 URL 参数，保持地址栏干净
      this.$router.replace('/overview');
    } else {
      // 从 cookie 中获取上次选择的空间
      const currentSpaceInfo = this.$cookies.get("currentSpaceInfo");
      if (currentSpaceInfo) {
        try {
          const parsedInfo = typeof currentSpaceInfo === "string"
            ? JSON.parse(currentSpaceInfo)
            : currentSpaceInfo;
          this.currentSpaceInfo = parsedInfo;
        } catch (e) {
          console.error("解析 currentSpaceInfo 失败:", e);
        }
      }
    }
    
    // 获取设备标签
    this.getTags();
  },
  watch: {
    currentSpaceInfo: {
      handler(newVal, oldVal) {
        // 只有在空间真正切换时才重新获取标签（避免初始化时重复调用）
        if (oldVal && oldVal.id !== newVal.id) {
          // 空间切换时清除高亮设备ID
          this.highlightDeviceId = '';
          this.getTags();
        }
      },
      deep: true,
    },
  },
  methods: {
    clickSpaceTree() {
      this.spaceTreeDisable = !this.spaceTreeDisable;
      this.$refs.indoor.closeDetail();
    },
    
    spaceClick(data) {
      this.$refs.indoor.closeDetail();
      this.currentSpaceInfo = data;
      // 防止子节点太大，清空子节点
      if (this.currentSpaceInfo.children) {
        this.currentSpaceInfo.children = [];
      }
      this.$cookies.set("currentSpaceInfo", JSON.stringify(data));
      this.spaceTreeDisable = false;
    },

    // 从IndoorSettingView移过来的方法
    // 获取设备标签
    getTags() {
      // 从 cookie 获取要选中的 tagId（可能是从告警中心跳转过来设置的）
      const savedTagId = this.$cookies.get("selectedTagId");
      
      // 从 cookie 获取需要高亮的设备ID（只获取一次，不删除）
      if (!this.highlightDeviceId) {
        const highlightDeviceId = this.$cookies.get("highlightDeviceId");
        if (highlightDeviceId) {
          this.highlightDeviceId = highlightDeviceId;
        }
      }
      
      getListByParentCode("device_category_tag").then(res => {
        if (res.code === 0) {
          const tags = [];
          res.data = res.data.filter(item => item.isDisplay)
          let hasSelected = false;
          
          res.data.forEach((item, index) => {
            item.isCheck = false;
            item.class = item.code.split("_")[0];
            
            // 优先使用保存的 tagId 匹配
            if (savedTagId && item.id === savedTagId) {
              this.tagSelected = item.id;
              this.tagSelectedCode = item.code;
              item.isCheck = true;
              item.class = item.class + "-selected";
              hasSelected = true;
            } 
            // 其次使用 tagCode 匹配
            else if (this.tagCode && this.tagCode === item.code) {
              this.tagSelected = item.id;
              this.tagSelectedCode = item.code;
              item.isCheck = true;
              item.class = item.class + "-selected";
              hasSelected = true;
            }
            // 如果都没有，默认选中第一个
            else if (!hasSelected && index === 0 && !savedTagId && !this.tagCode) {
              this.tagSelected = item.id;
              this.tagSelectedCode = item.code;
              item.isCheck = true;
              item.class = item.class + "-selected";
              hasSelected = true;
            }
            
            tags.push(item);
          })
          this.tagList = tags;
          
          // 标签加载完成后，清除相关 cookie
          if (savedTagId) {
            this.$cookies.remove("selectedTagId");
          }
          if (this.highlightDeviceId) {
            // 延迟清除，确保子组件已经接收到值
            setTimeout(() => {
              this.$cookies.remove("highlightDeviceId");
            }, 2000);
          }
        }
      })
    },

    //更换选中图标
    changeInput(id, name) {
      console.log(name);
      this.$refs.indoor.closeDetail();
      this.tagList.map(item => {
        if (item.id === id) {
          this.tagSelected = id
          this.tagSelectedCode = item.code
          this.labelName = item.name
          item.isCheck = true
        } else {
          item.isCheck = false
        }
      })
    },
    
    screenData(data) {
      this.screenDatas = data;
    }
  }
};
</script>
  
<style scoped>
.overview {
  width: 100%;
  height: 100%;
}

.header-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.space-selector {
  display: flex;
  align-items: center;
  padding: 5px 0;
  min-width: 200px;
}

/* 水平导航样式 */
.device-nav-container {
  flex: 1;
}

.device-nav {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  justify-content: flex-end;
}

.device-nav-item {
  color: #0098FF;
  padding: 8px 15px;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
}

.device-nav-item:hover {
  color: #fff;
}

.device-nav-item.active {
  color: #fff;
}

/* 保留原有的样式以防需要 */
.deviceTypeUl {
  display: none; /* 隐藏旧的样式 */
}
</style>
  